/**
 * API Configuration - Centralized Single Source of Truth
 * Uses relative paths that nginx will proxy to backend services
 */

export interface ApiEndpoints {
  authApi: string;
  schoolApi: string;
  learningApi: string;
  cdnBaseUrl: string;
}

// Centralized configuration - Use relative paths for nginx proxy
const getApiEndpoints = (): ApiEndpoints => {
  // Use relative paths that nginx will proxy to backend services
  const authApi = '/api/auth';
  const schoolApi = '/api/school';
  const learningApi = '/api/learning';
  const cdnBaseUrl = '/api/cdn';

  return {
    authApi,
    schoolApi,
    learningApi,
    cdnBaseUrl
  };
};

export const API_ENDPOINTS = getApiEndpoints();

// Debug logging based on environment
const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
console.log(`🚀 ${environment.toUpperCase()} CMS Configuration:`);
console.log('Environment:', environment);
console.log('Auth API:', API_ENDPOINTS.authApi);
console.log('School API:', API_ENDPOINTS.schoolApi);
console.log('Learning API:', API_ENDPOINTS.learningApi);
console.log('CDN Base URL:', API_ENDPOINTS.cdnBaseUrl);
